import { message } from "antd";
import InternalApi from "../axios/internalApi";

export const getUser = async () => {
  try {
    return await InternalApi.get({ server: "api/v1/", path: "user" });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const addPromoCode = async (payload) => {
  try {
    return await InternalApi.post(
      { server: "api/v1/", path: "promo-code" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getPromoCode = async (id) => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `promo-code?businessId=${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const createPromoCode = async (payload) => {
  try {
    return await InternalApi.post(
      { server: "api/v1/", path: "promo-code/promo-code" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getPromoCodeList = async (pageNumber = 1, itemPerPage = 10, text) => {
  try {
    return await InternalApi.get({ 
      server: "api/v1/", 
      path: `promo-code/list?pageNumber=${text ? 1 : pageNumber}&itemPerPage=${itemPerPage}${text ? `&text=${text}` : ""}`
  });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updatePromoCode = async (id, payload) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `promo-code/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const deletePromoCode = async (id) => {
  try {
    return await InternalApi.delete({
      server: "api/v1/",
      path: `promo-code/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getPromoCodeById = async (id) => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `promo-code/details/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const promoCodeVendor = async (payload) => {
  try {
    return await InternalApi.post(
      { server: "api/v1/", path: "promo-code/stripe" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getEmoji = async () => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `user/get-emoji`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const createEmoji = async (payload) => {
  try {
    return await InternalApi.post(
      { server: "api/v1/", path: "admin/emoji" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};